import Quill from 'quill';
import { QuillImageResize } from './quill-image-resize';

const HEADER_TO_SIZE: Record<number, string> = {
  1: '24px',
  2: '18px',
  3: '16px'
};

const SizeStyle = Quill.import('attributors/style/size');
SizeStyle.whitelist = ['16px', '18px', '24px'];
Quill.register(SizeStyle, true);
Quill.register('modules/imageResize', QuillImageResize, true);

function aplicarListaConservandoTamano(this: { quill: any }, value: string | false): void {
  const range = this.quill.getSelection(true);
  if (range) {
    const header = this.quill.getFormat(range)?.header;
    const size = HEADER_TO_SIZE[Number(header)];
    if (size) {
      this.quill.format('header', false, 'user');
      this.quill.format('size', size, 'user');
    }
  }
  this.quill.format('list', value, 'user');
}

export const QUILL_CORREO_MODULES = {
  toolbar: {
    container: [
      [{ size: ['24px', '18px', '16px', false] }],
      [{ font: [] }],
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ align: [] }],
      ['link', 'image']
    ],
    handlers: {
      list: aplicarListaConservandoTamano
    }
  },
  imageResize: true
};

export const QUILL_CORREO_STYLES = {
  minHeight: '180px'
};
